// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3JUO-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3Z5eI"};